import { OpenResourceCardTask } from '@/Core/Tasks/Resources/OpenResourceCardTask'

import { DriverResource } from '@/Containers/TransportSection/DriverContainer/Resources/DriverResource'
import { VehicleResource } from '@/Containers/TransportSection/VehicleContainer/Resources/VehicleResource'
import { UserResource } from '@/Containers/SettingSection/UserContainer/Resources/UserResource'

import type { CompletionGroupBy, RatingGroupBy, ReportGroupBy, ReportGroupRow } from '../Contracts/Report'
import { formatPeriodKey } from './reportPeriod'

export const COMPLETION_GROUPS: { value: CompletionGroupBy; label: string }[] = [
    { value: 'driver', label: 'Водій' },
    { value: 'vehicle', label: 'ТЗ' },
    { value: 'carrier', label: 'Перевізник' },
    { value: 'dispatcher', label: 'Диспетчер' },
    { value: 'day', label: 'День' },
    { value: 'week', label: 'Тиждень' },
    { value: 'month', label: 'Місяць' },
]

export const RATING_GROUPS: { value: RatingGroupBy; label: string }[] = [
    { value: 'dispatcher', label: 'Диспетчери' },
    { value: 'driver', label: 'Водії' },
]

/** Заголовок колонки групи */
export const GROUP_TITLES: Record<ReportGroupBy, string> = {
    driver: 'Водій',
    vehicle: 'Транспортний засіб',
    carrier: 'Перевізник',
    dispatcher: 'Диспетчер',
    day: 'День',
    week: 'Тиждень',
    month: 'Місяць',
}

/** Підпис групи без значення (задачі без водія, ТЗ тощо) */
const EMPTY_LABELS: Record<ReportGroupBy, string> = {
    driver: 'Без водія',
    vehicle: 'Без ТЗ',
    carrier: 'Без перевізника',
    dispatcher: 'Без диспетчера',
    day: '—',
    week: '—',
    month: '—',
}

/** Ключ групи для API деталізації: `none` — група без значення */
export const groupKeyParam = (row: ReportGroupRow): string => row.key ?? 'none'

export const isPeriodGroup = (groupBy: ReportGroupBy): groupBy is 'day' | 'week' | 'month' =>
    groupBy === 'day' || groupBy === 'week' || groupBy === 'month'

/** Назва групи в таблиці; null — група без значення */
export const groupLabel = (groupBy: ReportGroupBy, row: ReportGroupRow): string | null => {
    if (row.key === null) return null
    if (isPeriodGroup(groupBy)) return formatPeriodKey(groupBy, row.key)
    return row.label ?? `#${row.key}`
}

export const emptyGroupLabel = (groupBy: ReportGroupBy): string => EMPTY_LABELS[groupBy]

/** Картка сутності групи (водій, ТЗ, диспетчер); для перевізника й періодів — немає */
const GROUP_RESOURCES: Partial<Record<ReportGroupBy, any>> = {
    driver: DriverResource,
    vehicle: VehicleResource,
    dispatcher: UserResource,
}

export const canOpenGroupCard = (groupBy: ReportGroupBy, row: ReportGroupRow): boolean =>
    row.uuid !== null && GROUP_RESOURCES[groupBy] !== undefined

export const openGroupCard = (groupBy: ReportGroupBy, row: ReportGroupRow): void => {
    const resource = GROUP_RESOURCES[groupBy]
    if (!resource || !row.uuid) return
    OpenResourceCardTask({ resource, primaryFieldValue: row.uuid, mode: 'view' })
}
